import { Constants } from "common/constants";
import { UserAuthGuard } from "components/authguard/UserAuthGuard";
import { DecoodaProjectManagementMain } from "pages/decoodaprojectmanagement";
import { DecoodaProjectsMain } from "pages/decoodaprojects";
import { RouteObject } from "react-router-dom";

export const DecoodaRoutes: RouteObject[] = [
  {
    path: "/ai-analytics",
    handle: { pageTitle: "AI Analytics - Projects" },
    element: (
      <UserAuthGuard
        component={<DecoodaProjectsMain />}
        anyOf={[Constants.DECOODA_USERS_GROUP_NAME_VALUE]}
      />
    ),
  },
  {
    path: "/ai-analytics/:projectId",
    handle: { pageTitle: "AI Analytics - Project Management" },
    element: (
      <UserAuthGuard
        component={<DecoodaProjectManagementMain />}
        anyOf={[Constants.DECOODA_USERS_GROUP_NAME_VALUE]}
      />
    ),
  },
];
